// extracted by mini-css-extract-plugin
module.exports = {"filter":"styles_filter__WJOuO","filter_panel":"styles_filter_panel__pMBj_","parametrs":"styles_parametrs__3FJ7W","item":"styles_item__Tq9Q2","actions":"styles_actions__3Ibg8"};